import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { TIDS } from "@/constants/testIds";
import { Trophy, Calendar, Users } from "lucide-react";

export default function Tournaments() {
  const [list, setList] = useState([]);
  const { user } = useAuth();

  const load = () => api.get("/tournaments").then(r => setList(r.data));
  useEffect(() => { load(); }, []);

  const join = async (id) => {
    if (!user) {
      window.location.href = "/login";
      return;
    }
    await api.post(`/tournaments/${id}/join`);
    load();
  };

  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-10">
      <div className="relative rounded-md overflow-hidden mb-10">
        <img src="https://images.pexels.com/photos/9072293/pexels-photo-9072293.jpeg" className="w-full h-56 object-cover opacity-50" alt=""  loading="lazy" decoding="async" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#09090B] via-[#09090B]/70 to-transparent" />
        <div className="absolute inset-0 flex flex-col justify-center px-8">
          <div className="sc-label text-[#00E5FF]">Compete</div>
          <h1 className="sc-heading text-4xl sm:text-5xl font-black mt-1">Tournaments &amp; Prizes</h1>
          <p className="text-sm text-zinc-300 max-w-md mt-2">Skill-based brackets. Win Steam gift cards and bragging rights. No cash gambling.</p>
        </div>
      </div>

      <div className="border border-white/10 rounded-md overflow-hidden">
        <div className="grid grid-cols-12 px-4 py-3 text-xs sc-label border-b border-white/10 bg-black/30">
          <div className="col-span-5">Tournament</div>
          <div className="col-span-2">Game</div>
          <div className="col-span-2">Prize</div>
          <div className="col-span-2">Players</div>
          <div className="col-span-1 text-right">Action</div>
        </div>
        {list.length === 0 && <div className="p-8 text-center text-zinc-400 text-sm">No tournaments yet.</div>}
        {list.map((t) => (
          <div data-testid={TIDS.tournamentRow} key={t.id} className="grid grid-cols-12 px-4 py-4 items-center border-b border-white/5 hover:bg-white/[0.02] transition">
            <div className="col-span-5">
              <div className="flex items-center gap-2">
                <Trophy className="w-4 h-4 text-[#F59E0B]" />
                <div>
                  <div className="text-sm font-semibold">{t.name}</div>
                  <div className="text-[11px] text-zinc-500 flex items-center gap-1 mt-0.5">
                    <Calendar className="w-3 h-3" /> {new Date(t.starts_at).toLocaleString()}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-2 text-xs uppercase tracking-widest text-[#00E5FF]">{t.game_slug}</div>
            <div className="col-span-2 text-sm font-bold text-[#10B981]">{t.prize}</div>
            <div className="col-span-2 text-sm flex items-center gap-1.5 text-zinc-300"><Users className="w-3.5 h-3.5" /> {t.participants}</div>
            <div className="col-span-1 text-right">
              <button data-testid={TIDS.tournamentJoin} onClick={() => join(t.id)} className="sc-btn text-xs px-3 py-1.5">Join</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
